import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-traval-booking',
  templateUrl: './traval-booking.component.html',
  styleUrls: ['./traval-booking.component.scss']
})
export class TravalBookingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }



  
}
